import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { NavigationExtras, ActivatedRoute, Router } from '@angular/router';
import { UtilitiesService } from 'src/app/core/utilities.service';

@Component({
  selector: 'app-e-ticketing-list',
  templateUrl: './e-ticketing-list.component.html',
  styleUrls: ['./e-ticketing-list.component.scss']
})
export class ETicketingListComponent implements OnInit {

    bearer;
    feedback = [];
    feedbackList = [];
    topicId;
    id:any;
    sub;

    page = 1;
    selectedPage = 10;
    start = 0;
    end = 0;
    loading = true;
    expanded = [];

    constructor(
      private svc: StoreService,
      private router: Router,
      private route: ActivatedRoute,
      public utils: UtilitiesService,
    ) { }

    ngOnInit(): void {
      this.sub = this.route.params.subscribe(params => {
           this.id = params['id'];
      });
      this.bearer = localStorage.getItem('bearer');
      this.ionViewDidEnter();
    }

    ionViewDidEnter() {
        this.svc.getFeedbackList(this.bearer ).subscribe(res => {
          this.feedback = res['data'];
          console.log(this.feedback);
          this.sliceCart();
          this.loading = false;
        })
      }

      goFeedbackFormPage(id){
       //this.router.navigate(['/property-detail',id]);
       let navigationExtras: NavigationExtras = {
         state: {
           topicId: this.topicId
         }
       };
       this.router.navigate(['/dashboard/e-ticketing-info',id], navigationExtras);
     }

     sliceCart() {
         this.start = Math.round((this.page-1) * this.selectedPage);
         this.end = this.start + this.selectedPage;
         this.end = this.end > this.feedback.length ? this.feedback.length : this.end;
         this.end = this.end > this.start ? this.end : this.start;
         this.feedbackList = this.feedback.slice(this.start, this.end);
         if (this.feedbackList.length > 0) {
             this.feedbackList.forEach((value, index) => {
                 this.expanded[index] = false;
             });
         }
     }

     selectPage(page: any) {
         this.selectedPage = page;
         this.page = 1;
         this.sliceCart();
     }

     changePage(pageOfItems) {
         this.page = pageOfItems;
         this.sliceCart();
     }

  }
